import { Component, Output, OnInit, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { FilterPipe } from 'src/app/pipes/filter.pipe';
import { take } from 'rxjs/operators';
import { BaseFormService } from 'src/app/services/base-form.service';
import { GerenciarPermissoesService } from 'src/app/services/gerenciar-permissoes.service';
import { LoadingGenericoComponent } from '../../../components/loading-generico/loading-generico.component';
import { FormsModule } from '@angular/forms';
import { ClickedOutsideDirective } from '../../../directives/clicked-outside.directive';
import { SelectComponent } from '../../../components/select/select.component';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-gerenciar-permissoes-enderecos',
    templateUrl: './gerenciar-permissoes-enderecos.component.html',
    styleUrls: ['./gerenciar-permissoes-enderecos.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, FormsModule, ClickedOutsideDirective, SelectComponent, NgxPaginationModule]
})
export class GerenciarPermissoesEnderecosComponent extends BaseFormService implements OnInit {

  public filterResouce: any = [];
  public term: any;
  public searchTextFilterUsers : any = '';

  public checkBox: boolean = false;
  public loadingGenerico: boolean = false;
  public selectedAddress : number[] = [];
  public aparecer : boolean = false;

  @Input() idContato: any;
  public enderecoList: any = [];
  public itemsPerPage = 5;
  public currentPage = 1;
  public totalItems = this.enderecoList.length;
  public empresa: any = localStorage.idEmpresaLogada;
  public totalItemsExiba:any;
  public enderecoListFiltrado:any;

  public erro: boolean = false;
  public checkSelectAllClick: boolean = false;
  public checkAll : boolean;

  public listaEnderecosPerm: any;

  @Output() salvarEventEmitter = new EventEmitter<number[]>();

  constructor(
    private readonly gerenciarPermissoesService: GerenciarPermissoesService,
    private readonly filterPipe: FilterPipe
  ) { super(); }

  ngOnInit(): void {
    this.getApiData();
    this.getEnderecosPermissoes();
  }

  clickOutside() {
    this.filterResouce = [];
  }

  public searchUserFilter() {

    this.searchTextFilterUsers = this.term;
    this.getSearchResults();

    this.getPage(1);
  }

  getSearchResults(){
    const results = this.filterPipe.transform(this.enderecoList , this.searchTextFilterUsers  )
    this.totalItemsExiba = results.length;
    this.enderecoListFiltrado = results;
  }

  getApiData() {

    this.loadingGenerico = true;
    this.gerenciarPermissoesService.getEnderecos(this.empresa)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        this.loadingGenerico = false;
        this.enderecoList = response.response;
        this.getSearchResults();
        this.totalItemsExiba = response.response.length
        this.erro = false;
      }, error: (error: any) => {
        this.loadingGenerico = false;
        this.erro = true;
      }
    });
  }

  public getEnderecosPermissoes() {

    this.loadingGenerico = true;
    this.gerenciarPermissoesService.getPermissoes(this.idContato.id)
      .pipe(take(1))
      .subscribe({
        next: (success: any) => {
          this.selectedAddress = success.response[0].idEndereco
        }, error: () => {
          this.loadingGenerico = false;
        }
      });
  }

  clickEmpresa(empresa) {
    this.term = empresa.razaoSocial;

    this.filterResouce = [];
  }

  getPage(page: number) {

    this.currentPage = page;
  }

  onTableAddressClick(idEndereco) {
    let index = this.selectedAddress.findIndex(x => x == idEndereco);
    if (index < 0) {
      this.selectedAddress.push(idEndereco);
    }
    else {
      this.selectedAddress.splice(index, 1);
    }
    if(this.selectedAddress.length == this.totalItemsExiba){
      this.checkAll = true;
    }
    else {
      this.checkAll = false;
    }
  }

  selectAll( event : any) {
    if (event.target.checked) {
      this.selectedAddress = [];

      this.enderecoList.forEach(element => {
        this.selectedAddress.push(element.idEndereco);
      });
      this.checkSelectAllClick = !this.checkSelectAllClick
    } else {
      this.selectedAddress = [];
      this.checkSelectAllClick = false;
    }
    this.checkAll = this.selectedAddress.length == this.totalItemsExiba;

  }

  isChecked(idEndereco) {
    let index = this.selectedAddress.findIndex(x => x == idEndereco);

    return (index >= 0);

  }

  salvar(){
    this.salvarEventEmitter.emit ( this.selectedAddress );
  }
}
